import React, { useEffect, useState } from "react";
import locale from 'locale';
import { Table, Button, ButtonToolbar } from 'react-bootstrap';
import PaginationBar from "components/PaginationBar";

const PAGE_SIZE = 30;

const LoadingClients = ({ users, fields, onApply, onClose }) => {
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);

    useEffect(() => {
        if (users.length > PAGE_SIZE) setPageCount(Math.ceil(users.length / PAGE_SIZE));
    }, [users]);

    return (users?.length
        ? <>
            <Table>
                <thead>
                    <tr>
                        {
                            fields.map((field, index) => (
                                <th key={index}>{field[`label_${locale.currentLocaleName}`]}</th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        users
                            .slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)
                            .map((userData, index) => (
                                <tr key={index}>
                                    {
                                        fields.map((field) => (
                                            <td key={field.name}>{userData?.[field.name]?.toString() ?? '–'}</td>
                                        ))
                                    }
                                </tr>
                            ))
                    }
                </tbody>
            </Table>
            {
                users.length > PAGE_SIZE &&
                <PaginationBar
                    activePage={+page ?? 1}
                    pageCount={+pageCount ?? 1}
                    onSelect={(page) => setPage(page)}
                />
            }
            <ButtonToolbar>
                <Button onClick={onApply} bsStyle="primary">Импорт</Button>
                <Button onClick={onClose}>Вернуться</Button>
            </ButtonToolbar>
        </>
        : <></>
    );
};

export default LoadingClients;
